"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var Money_1 = __importDefault(require("components/Money"));
var BrandedServiceLink_1 = __importDefault(require("shared/hds/BrandedServiceLink"));
var NewService = function (_a) {
    var _b;
    var notifications = _a.notifications;
    var _c = __read(notifications, 1), notif = _c[0];
    var annualSpend = (_b = notif === null || notif === void 0 ? void 0 : notif.serviceStat) === null || _b === void 0 ? void 0 : _b.calculatedAnnualSpend;
    if (!(notif === null || notif === void 0 ? void 0 : notif.service)) {
        // ToDo: use error boundaries and better error logging
        return null;
    }
    if (notif.stageAdded === 'SETUP') {
        return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(BrandedServiceLink_1.default, { service: notif === null || notif === void 0 ? void 0 : notif.service }), " detected for", ' ', (0, jsx_runtime_1.jsx)("strong", { children: (0, jsx_runtime_1.jsx)(Money_1.default, { amount: annualSpend }) }), " in the last 12 months."] }));
    }
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)("strong", { children: "Your company" }), " signed up for ", (0, jsx_runtime_1.jsx)(BrandedServiceLink_1.default, { service: notif.service }), " ", !annualSpend && '.', !!annualSpend && (0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)("strong", { children: (0, jsx_runtime_1.jsx)(Money_1.default, { amount: annualSpend }) }), " in the last 12 months."] }), notif.service.description ? " ".concat(notif.service.description.split('.')[0], ".") : ''] }));
};
exports.default = NewService;
